module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud.86f4a7e9219cb9901b78484dddc8bc37.svg";